import MessageFormat from 'messageformat';

export default class CustomFormatter {
  constructor(options = {}) {
    this.locale = options.locale || 'en-US';
    this.formatter = new MessageFormat(this.locale);
    // this.formatter.setIntlSupport(true);
    this.caches = Object.create(null);
  }

  interpolate(message, values) {
    let fn = this.caches[message];
    if (!fn) {
      fn = this.formatter.compile(message, this.locale);
      this.caches[message] = fn;
    }
    return [fn(values)];
  }
}
